import { render } from "./StockDatabase.vue?vue&type=template&id=6f7d9867&scoped=true"
import script from "./StockDatabase.vue?vue&type=script&lang=js"
export * from "./StockDatabase.vue?vue&type=script&lang=js"

import "./StockDatabase.vue?vue&type=style&index=0&id=6f7d9867&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7d9867"]])

export default __exports__